/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum CarouselDataStatusEnum {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED'
}
